var render = function render() {
  var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy;return _c('div', { staticClass: "version-name" }, [_c('div', { staticClass: "version-name-hd" }, [_c('el-tag', { attrs: { "type": _vm.tagType } }, [_vm._v(_vm._s(_vm.versionNameLabel))])], 1), _vm._v(" "), _c('div', { staticClass: "version-name-bd" }, [_c('span', { staticClass: "version-num" }, [_vm._v(_vm._s('Version' + _vm.versionNum))]), _vm._v(" "), _c('span', { staticClass: "name" }, [_vm._v(_vm._s(_vm.name))])])]);
};
var staticRenderFns = [];

export { render, staticRenderFns };